import { useEffect, useRef, useState } from 'react'

import {
  resetBuildProgressConfig,
  useCloseModal,
  useConfigureModalController,
  useModalController,
} from '@/atoms'

import { useBuildProgress } from './useBuildProgress'

type ModalState = 'ready'

export interface ModalData {
  progress: number | 'completed'
  canDiscard: boolean
  discarding: boolean
  showDiscardConfirm: boolean
}

export const modalId = 'buildProgress'

export const useController = () => useModalController<ModalData, ModalState>(modalId)

export const useConfigureController = () => {
  const progress = useBuildProgress()
  const closeModal = useCloseModal()

  const [options] = useState(() => ({
    createInitialState: () => ({
      data: {
        progress,
        canDiscard: false,
        discarding: false,
        showDiscardConfirm: false,
      },
      close: () => {
        resetBuildProgressConfig()
        closeModal()
      },
    }),
  }))

  const ctrl = useConfigureModalController<ModalData, ModalState>(modalId, options)
  const { updateData } = ctrl

  const api = useRef({ updateData })

  useEffect(() => {
    api.current.updateData = updateData
  }, [updateData])

  // Mirror the live progress notification into modal data
  useEffect(() => {
    api.current.updateData({ progress })
  }, [progress])

  // Discard button appears after 8 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      api.current.updateData({ canDiscard: true })
    }, 8000)
    return () => clearTimeout(timer)
  }, [])

  return ctrl
}
